import Api from '../../helpers/api';
import Locations from '../../helpers/locations';
import Constants from './Feedbackconstant';


export const checkUserExisting = (email,booking) => {
    console.log(email,booking,"<<<<")
    return function (dispatch) {

       const param = {
            email,
            booking
        }
        const successCall = (response) => {
            dispatch({
                type: Constants.ACTIONS.GET_USER_EXISTING_SUCCESS,
                payload: response
            });
        };

        const errorCall = (errorResponse) => {
            dispatch({
                type: Constants.ACTIONS.GET_USER_EXISTING_FAILED,
                payload: errorResponse
            });
        }

        Api.doGet(Locations.serviceUserExisting, param, successCall, errorCall);
    }
}

export const getQuestions = () => {
  
    return function (dispatch) {

        const successCall = (response) => {
            dispatch({
                type: Constants.ACTIONS.GET_QUESTIONS_DATA_SUCCESS,
                payload: response?.results
            });
        };

        const errorCall = (errorResponse) => {
            dispatch({
                type: Constants.ACTIONS.GET_QUESTIONS_DATA_FAILED,
                payload: errorResponse
            });
        }

        Api.doGet(Locations.serviceQuestions, {}, successCall, errorCall);
    }
}

export const postResponseData = (body) => {
  
    return function (dispatch) {

        const successCall = (response) => {
            dispatch({
                type: Constants.ACTIONS.POST_QUESTIONS_DATA_SUCCESS,
                payload: response
            });
        };

        const errorCall = (errorResponse) => {
            dispatch({
                type: Constants.ACTIONS.POST_QUESTIONS_DATA_FAILED,
                payload: errorResponse
            });
        }

        Api.doPost(Locations.serviceUserExisting, body, successCall, errorCall);
    }
}

export default {
    getQuestions,
    postResponseData,
    checkUserExisting
}